import { AllRoutes } from "../../Routes/router";
import { getDocumentToken, url } from "../APIEndPoints/EndPoints";
import { ApiStatus } from "../Enums/ApiStatus";
import { RoleEnum } from "../Enums/RoleEnum";
import { APICall } from "../Network/APICalls";
import * as _ from "lodash";

export const getBase64FromFile = (file: any, cb: any) => {
  if (isFile(file) === true) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
     
    };
  }
};

export const base64ToArrayBuffer = (base64) => {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  } /*from  w w w  . j  ava  2  s .  c o  m*/
  return bytes;
};
export const getBase64FromFilePromise = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    if (isFile(file) === true) {
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    }
    reader.onerror = (error) => reject(error);
  });

export const isFile = (input: any) => "File" in window && input instanceof File;

export const getDefaultDashboard = (roleId) => {
  let page = AllRoutes.LoanApprovalDashboard.link;
  switch (roleId) {
    case RoleEnum.Admin:
      page = AllRoutes.MemberVerification.link;
      break;
    case RoleEnum.Member:
      page = AllRoutes.MemberDashboard.link;
      break;
    case RoleEnum.InternalTeam:
      page = AllRoutes.MemberVerification.link;
      break;
    case RoleEnum.EnrollmentCommittee:
      page = AllRoutes.MemberVerification.link;
      break;
    case RoleEnum.LoanCommittee:
      page = AllRoutes.LoanApprovalDashboard.link;
      break;
    case RoleEnum.HRHOD:
      page = AllRoutes.MemberVerification.link;
      break;
    default:
      page = AllRoutes.login.link;
      break;
  }
  return page;
};

export const randomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};
export const randomNumber = (start, end) => {
  return _.random(start, end);
};
export const randomDate = (start, end) => {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};
export const randomEmail = () => {
  return `${randomString(10)}@${randomString(6)}.${randomString(3)}`;
};
export const randomMobile = () => {
  return randomNumber(1111111111, 9999999999);
};

export const hasOnlyDigits = (str: string) => {
  return /^-?\d+$/.test(str);
};

export const isDev = () => {
  return url.includes("localhost"); // || url.includes("creditsociety-dev"); // || url.includes("creditsociety-uat");
};

export const sleep = (time) => new Promise((resolve, reject) => setTimeout(resolve, time));

export const getFormattedCurrencyValue = (str) => {
  return `${str}`.replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,");
};
export const getFormattedCurrencyValueWithSymbol = (str) => {
  return `₹ ${str}`.replace(/(\d)(?=(\d{2})+\d(?!\d))/g, "$1,");
};
export const base64UrlEncode = (input) => {
  // Standard base64 encoding
  let encoded = btoa(input);

  // Base64Url requires certain characters to be replaced
  return encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};

export const base64UrlDecode = (input) => {
  // Base64Url requires certain characters to be replaced back
  let padded = input.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding back if necessary
  let padding = padded.length % 4;
  if (padding === 1) {
    throw new Error("Invalid base64url string");
  }
  if (padding > 0) {
    padded += "=".repeat(4 - padding);
  }

  // Standard base64 decoding
  return atob(padded);
};
